// angular
import { CommonModule } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
// components
import { ButtonComponent } from '@app/core/components/button/button.component';
import { ChatHeaderComponent } from './components/chat-header/chat-header.component';
import { ChatMessagesContainerComponent } from './components/chat-messages-container/chat-messages-container.component';
// services
import { StateManagementService } from './shared/services/state-management.service';
// types
import { MessagePayload } from 'firebase/messaging';

@Component({
  selector: 'pwj-chat-box',
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    ChatHeaderComponent,
    ChatMessagesContainerComponent,
  ],
  templateUrl: './chat-box.component.html',
  styleUrl: './chat-box.component.scss',
  host: { ngSkipHydration: 'true' },
})
export class ChatBoxComponent {
  public currentChatId!: string | null;
  public isChatOpened: boolean = false;
  public notifications!: MessagePayload[];

  // dependencies
  private readonly _stateManagementService = inject(StateManagementService);

  constructor() {
    // set chat box state
    effect(() => {
      this.isChatOpened = this._stateManagementService.isChatBoxOpen();
    });

    // set notifications data
    effect(() => {
      this.notifications = this._stateManagementService.messagesNotifications();
    });

    // get chat data
    effect(() => {
      this.currentChatId =
        this._stateManagementService.oneChatById()?._id || null;
    });
  }

  public toggleChatBox() {
    // toggle chat box
    this._stateManagementService.isChatBoxOpen.set(true);
    // make notifications list empty
    this._stateManagementService.messagesNotifications.set([]);
  }
}
